<template>
  <div>
    <div class="selected-service-border">
      <div class="row select-edit confirmation-page">
        <div class="col-lg-11 col-md-11 col-sm-11 col-xs-10">
          <span class="cnf-select-service hidden-xs">
            <span v-if="paymentStatus">Purchased</span>
            <span v-else> Selected</span></span
          >
          <span class="cnf-select-service hidden-lg hidden-md hidden-sm">
            <span v-if="paymentStatus">Purchased Services</span>
            <span v-else>Selected Services</span></span
          >
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 cnf-end" v-if="!paymentStatus">
          <p @click="editSlide(0)">Edit</p>
        </div>
      </div>
      <hr class="cnf-hr-line" />
      <template v-if="!teamMemberData">
        <div class="row confirmation-page">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-sm-12 cnf-selected">
                <p>{{ serviceSelected.name }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-sm-12 cnf-single-service">
                <p v-if="serviceSelected.id !== 2 && !serviceSelected.is_bundle">Base Price</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div class="row">
              <div class="col-lg-8 col-md-7 col-sm-7 col-xs-8 cnf-selected renew_label pr-0">
                <p
                  v-if="
                    ((serviceMarket !== '' && serviceSelected.id === 2) ||
                      serviceSelected.id !== 2) &&
                    purchaseType !== 'upgrade'
                  "
                >
                  Renews {{ validUntil | dateFormat }}
                </p>
              </div>
              <div
                class="col-lg-4 col-md-5 col-sm-5 col-xs-4 cnf-selected text-end"
                v-if="purchaseType !== 'upgrade' || serviceSelected.id === 16"
              >
                <p v-if="serviceMarket == '' && serviceSelected.id === 2">Free</p>
                <p v-if="serviceSelected.id !== 2">
                  ${{ serviceSelected.price }}
                  <span
                    class="cnf-single-service hidden-xs"
                    v-if="
                      serviceSelected.id == 8 || serviceSelected.id == 9 || serviceSelected.id == 10
                    "
                    >per use</span
                  >
                  <span class="cnf-single-service hidden-xs" v-else>per year</span>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6"></div>
            </div>
          </div>
        </div>
        <hr class="cnf-hr-line hidden-xs" />
        <div
          v-if="serviceSelected.id === 1 || serviceSelected.id === 13 || serviceSelected.id === 14"
        >
          <div class="row confirmation-page" v-if="selectedRecords && selectedRecords.price">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-8 cnf-single-service">
              <p>
                {{ selectedRecords.value }} records &
                {{ selectedRecords.storage / (1024 * 1024) }}GB storage included
                <span v-if="selectedRecords.price === 0">for free</span>
              </p>
            </div>
            <div
              class="col-lg-8 col-md-8 col-sm-8 col-xs-4 cnf-selected text-end"
              v-if="selectedRecords.price != 0"
            >
              ${{ selectedRecords.price }}
              <span class="cnf-single-service hidden-xs">per year</span>
            </div>
          </div>
          <div
            class="row confirmation-page"
            v-if="
              purchaseType !== 'upgrade' && (serviceSelected.id === 13 || serviceSelected.id === 14)
            "
          >
            <div class="col-xs-12">
              <span class="">All Markets included under Regulatory Intelligence</span>
            </div>
          </div>
          <div
            class="row confirmation-page"
            v-if="purchaseType !== 'upgrade' && serviceSelected.id === 14"
          >
            <div class="col-xs-12">
              <span class="">All Markets included under Regulatory Reports</span>
            </div>
          </div>
          <div class="confirmation-page hidden-xs">
            <hr />
          </div>
        </div>
        <div v-if="serviceSelected.id === 16">
          <div class="row confirmation-page">
            <div class="col-xs-12">
              <span class="">All Markets included under Regulatory Reports</span>
            </div>
          </div>
          <!-- <div class="confirmation-page hidden-xs">
            <hr />
          </div> -->
        </div>
        <div
          v-if="
            purchaseType !== 'upgrade' && (serviceSelected.id === 15 || serviceSelected.id === 13)
          "
        >
          <div class="row confirmation-page">
            <div class="col-xs-12">
              <span class="">
                Markets selected under Regulatory Reports : {{ getCountriesList() }}</span
              >
            </div>
          </div>
          <div class="confirmation-page hidden-xs">
            <hr />
          </div>
        </div>
        <div v-if="serviceSelected.id === 7">
          <div
            class="row confirmation-page"
            v-if="selectedRecordsProdCls && selectedRecordsProdCls.price"
          >
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-8 cnf-single-service">
              <p>
                {{ selectedRecordsProdCls.name }} {{ serviceSelected.name }} requested
                <span v-if="selectedRecordsProdCls.price === 0">for free</span>
              </p>
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-4 cnf-selected text-end">
              <span class="cnf-single-service hidden-xs"></span>
            </div>
          </div>
          <div class="confirmation-page hidden-xs">
            <hr />
          </div>
        </div>
        <div v-if="serviceSelected.id === 8">
          <div
            class="row confirmation-page"
            v-if="selectedRecordsRegPathwy && selectedRecordsRegPathwy.price"
          >
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-8 cnf-single-service">
              <p>
                {{ selectedRecordsRegPathwy.name }} {{ serviceSelected.name }} requested
                <span v-if="selectedRecordsRegPathwy.price === 0">for free</span>
              </p>
            </div>
            <div
              class="col-lg-8 col-md-8 col-sm-8 col-xs-4 cnf-selected text-end"
              v-if="selectedRecordsRegPathwy.price != 0"
            >
              ${{ selectedRecordsRegPathwy.price }}
              <span class="cnf-single-service hidden-xs">total</span>
            </div>
          </div>
          <div class="confirmation-page hidden-xs">
            <hr />
          </div>
        </div>
        <div v-if="serviceSelected.id === 9 || serviceSelected.id === 10">
          <div
            class="row confirmation-page"
            v-if="selectedRecordsProdClsRat && selectedRecordsProdClsRat.price"
          >
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-8 cnf-single-service">
              <p>
                {{ selectedRecordsProdClsRat.name }} {{ serviceSelected.name }} requested
                <span v-if="selectedRecordsProdClsRat.price === 0">for free</span>
              </p>
            </div>
            <div
              class="col-lg-8 col-md-8 col-sm-8 col-xs-4 cnf-selected text-end"
              v-if="serviceSelected.id === 9 && selectedRecordsProdClsRat.price != 0"
            >
              ${{ selectedRecordsProdClsRat.price }}
              <span class="cnf-single-service hidden-xs">total</span>
            </div>
            <div
              class="col-lg-8 col-md-8 col-sm-8 col-xs-4 cnf-selected text-end"
              v-if="serviceSelected.id === 10"
            >
              ${{ serviceSelected.price }}
              <span class="cnf-single-service hidden-xs">total</span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row m-0 font-18 fw-400">
          <div class="col-sm-6 text-left">Current Account Add On</div>
          <div class="col-sm-6 text-right">Current Utilization</div>
        </div>
        <div class="row col-xs-12 m-0">
          <hr />
        </div>
        <div class="col-xs-12 p-0 mb-20 mt-8">
          <div class="col-xs-6 text-left service-header">
            <p>
              Total limit : <span v-if="isREP">{{ teamMemberData.total_limit - 1 }}</span
              ><span v-else>{{ teamMemberData.total_limit }}</span>
            </p>
            <p class="service-description mb-5">
              <span>Renews</span>
              {{ teamMemberData.valid_until | dateFormat }}
            </p>
          </div>
          <div
            class="col-xs-6 d-flex"
            :class="[teamMemberData.isRenewal ? 'justify-space-between' : 'justify-content-end']"
          >
            <div v-if="teamMemberData.isRenewal" class="renewal-label font-bold">
              New addon expires in {{ teamMemberData.valid_until | validTill }}
            </div>
            <div>
              <span v-if="isREP">{{ teamMemberData.current_utilization - 1 }}</span
              ><span v-else>{{ teamMemberData.current_utilization }}</span>
            </div>
          </div>
        </div>
        <div class="row col-xs-12 m-0">
          <hr />
        </div>
        <div class="row m-0 font-18 fw-400">
          <div class="col-sm-6 text-left">Upgrade Team Members</div>
          <div class="col-sm-6 text-right">Price</div>
        </div>
        <div class="row col-xs-12 m-0">
          <hr />
        </div>
        <div class="col-xs-12 p-0 mb-20 mt-8">
          <div class="col-xs-12 p-0">
            <div class="col-xs-5 text-left service-header">
              <p>Additional team members limit : {{ selectedRecords.value }} Members</p>
            </div>
            <div class="col-xs-7 text-right font-18 fw-400">
              <template
                v-if="
                  teamMemberData.total_limit <= teamMemberData.default_limit ||
                  teamMemberData.isRenewal
                "
              >
                <div class="col-xs-12 p-0 text-right">
                  <div class="col-xs-10 p-0">Total Price:</div>
                  <div class="col-xs-2 pr-0 word-break fw-500">${{ selectedRecords.price }}</div>
                </div>
              </template>
              <template v-else>
                <div class="col-xs-12 p-0 text-right">
                  <div class="col-xs-10 p-0">Actual price:</div>
                  <div class="col-xs-2 pr-0 word-break fw-500">${{ selectedRecords.price }}</div>
                </div>
              </template>
            </div>
          </div>
          <div class="col-xs-12 p-0">
            <div class="col-xs-5 text-left service-header">
              <ul class="pl-16">
                <li class="fw-400 text-secondary font-16">
                  Charges for add-ons may be prorated to align with validity of a previous Team
                  Member upgrade.
                </li>
              </ul>
            </div>
            <div class="col-xs-7 text-right font-18 fw-400">
              <div class="col-xs-12 p-0 text-right" v-if="teamMemberProRata">
                <div class="col-xs-10 p-0">Final price:</div>
                <div class="col-xs-2 pr-0 word-break fw-500">${{ teamMemberProRata.netPrice }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="confirmation-page hidden-xs">
          <hr />
        </div>
      </template>
    </div>

    <div class="selected-service-border">
      <div
        class="row confirmation-page"
        v-if="serviceCountry && !defaultCountry && serviceSelected.id === 2"
      >
        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
          <span class="cnf-select-service">Complimentary country selected</span>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 cnf-end">
          <p v-if="serviceCountry">{{ serviceCountry.country_name }}</p>
        </div>
      </div>
      <div
        class="row confirmation-page"
        v-if="serviceMarket == 'upgrade' && serviceSelected.id === 2"
      >
        <div class="col-lg-11 col-md-11 col-sm-11 col-xs-10">
          <span class="cnf-select-service">{{ serviceCountries.length }} Markets selected - </span>
          <span v-for="(country, index) in serviceCountries" :key="index"
            >{{ country.country_name
            }}<span v-if="serviceCountries.length > index + 1">, </span></span
          >
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 cnf-end">
          <p>{{ regIntelPrice }}</p>
        </div>
      </div>
      <div class="row confirmation-page" v-if="serviceMarket == 'all' && serviceSelected.id === 2">
        <div class="col-lg-11 col-md-11 col-sm-11 col-xs-10">
          <span class="cnf-select-service">All Markets</span>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 cnf-end">
          <p>${{ totalPrice }}/Year</p>
        </div>
      </div>
      <div
        class="row billing-info-edit confirmation-page"
        v-if="billingDetails && billingDetails.email_address && paymentSelected.id != 1"
      >
        <div class="col-lg-11 col-md-11 col-sm-11 col-xs-10">
          <span class="cnf-select-service">Billing Info</span>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2 cnf-end">
          <p @click="editSlide(2)">Edit</p>
        </div>
      </div>
      <hr
        class="cnf-hr-line"
        v-if="billingDetails && billingDetails.email_address && paymentSelected.id != 1"
      />
      <div
        class="row confirmation-page cnf-sm-address"
        v-if="billingDetails && paymentSelected.id != 1"
      >
        <div class="col-lg-4 col-md-4 col-sm-10 col-xs-10">
          {{ billingDetails.first_name }} {{ billingDetails.last_name }}
          <br />
          {{ billingDetails.email_address }}
          <br />
          {{ billingDetails.phone_number }}
          <br />
          {{ billingDetails.address }}
          <br />
          {{ billingDetails.city }}
          <br />
          {{ billingDetails.state }}
          <br />
          {{ billingDetails.country }}
          <br />
          {{ billingDetails.zipcode }}
        </div>
      </div>
      <div v-if="paymentSelected.id === 1" class="row confirmation-page">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 success-msg" v-if="paymentStatus">
          Credit card payment successful!
        </div>
        <br v-if="!paymentStatus" />
        <br />
        <br />
      </div>
      <div
        v-if="!(serviceMarket == '' && serviceSelected.id === 2)"
        class="row payment-mthd-edit confirmation-page"
      >
        <div class="col-lg-3 col-md-3 col-sm-3 hidden-xs">
          <span class="cnf-select-service">Payment Method</span>
        </div>
        <div
          class="col-lg-8 col-md-8 col-sm-7 col-xs-10 cnf-credit-card cnf-end"
          :class="{
            'col-lg-offset-1 col-md-offset-1 col-sm-offset-2 col-xs-offset-2': paymentStatus
          }"
        >
          {{ paymentSelected.mode }}
          <span v-if="paymentSelected.id === 3">: {{ billingDetails.purchase_order }}</span>
        </div>
        <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2 cnf-end" v-if="!paymentStatus">
          <p @click="editSlide(1)">Edit</p>
        </div>
      </div>
      <hr v-if="!(serviceMarket == '' && serviceSelected.id === 2)" class="cnf-hr-line" />
      <div
        v-if="
          (serviceSelected.id === 13 || serviceSelected.id === 14) &&
          proRataData &&
          Object.keys(proRataData).length &&
          proRataData.creditPrice
        "
        class="row confirmation-page cnf-sm-border mb-20"
      >
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 cnf-selected font-bold">
          <span>Credit Amount</span>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 cnf-selected text-end font-bold">
          ${{ proRataData.creditPrice }}
        </div>
      </div>
      <div
        v-if="!(serviceMarket == '' && serviceSelected.id === 2)"
        class="row confirmation-page cnf-sm-border"
      >
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 cnf-selected font-bold">
          <span v-if="!paymentStatus">Total</span>
          <span v-else>Amount paid</span>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-end">
          <span class="cnf-selected font-bold">${{ totalPrice }}</span>
          <div
            v-if="
              (serviceSelected.id === 13 || serviceSelected.id === 14) &&
              proRataData &&
              Object.keys(proRataData).length &&
              proRataData.creditPrice &&
              Math.sign(serviceSelected.price - proRataData.creditPrice) === -1
            "
          >
            (Credit ${{ Math.abs(serviceSelected.price - proRataData.creditPrice) }}. Please contact
            <a href="mailto:ramshelp@ul.com">RAMSHelp@ul.com</a> for support)
          </div>
        </div>
      </div>
      <div class="row confirmation-page pt-40 note-text">
        <div class="col-xs-12 col-md-12 col-sm-12 col-lg-12">
          <b>Note:</b> UL’s accounting system will automatically send an invoice to reflect your
          purchase in the next 7-10 days. Please disregard the balance due amount if you paid by
          credit card.
        </div>
      </div>
      <hr class="cnf-hr-line mb-0" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: [
    'selectedRecords',
    'teamMemberData',
    'selectedRecordsProdCls',
    'selectedRecordsProdClsRat',
    'selectedRecordsRegPathwy',
    'serviceSelected',
    'paymentSelected',
    'billingDetails',
    'validFrom',
    'validUntil',
    'serviceMarket',
    'serviceCountry',
    'serviceCountries',
    'regIntelPrice',
    'defaultCountry',
    'paymentStatus',
    'totalPrice',
    'selectedRegReportCountries',
    'proRataData',
    'purchaseType',
    'teamMemberProRata'
  ],
  data() {
    return {
      isREP: false
    };
  },
  computed: {
    todayDate() {
      return moment().utc().format('YYYY-MM-DD HH:mm:ss');
    }
  },
  methods: {
    editSlide(slideNumber) {
      this.$emit('editSlide', slideNumber);
    },
    renewStartDate() {
      return moment.utc('12/01/2021').format('YYYY-MM-DD HH:mm:ss');
    },
    renewEndDate() {
      return moment.utc('01/01/2022').format('YYYY-MM-DD HH:mm:ss');
    },
    getCountriesList() {
      if (this.selectedRegReportCountries) {
        if (
          this.selectedRegReportCountries !== 'all' &&
          this.selectedRegReportCountries.length === 1
        ) {
          return this.selectedRegReportCountries.map((e) => e.country_name).join('');
        }
        if (
          this.selectedRegReportCountries !== 'all' &&
          this.selectedRegReportCountries.length > 1
        ) {
          return `${this.selectedRegReportCountries
            .slice(0, this.selectedRegReportCountries.length - 1)
            .map((e) => e.country_name)
            .join(', ')} and ${
            this.selectedRegReportCountries[this.selectedRegReportCountries.length - 1].country_name
          }`;
        }
      }
      return '-';
    }
  },
  filters: {
    validTill(date) {
      return moment.utc(date).add(1, 'years').subtract(1, 'days').format('MM/DD/YYYY');
    },
    dateFormat(date) {
      return moment(date).format('MM/DD/YYYY');
    }
  },
  mounted() {
    this.isREP =
      JSON.parse(localStorage.getItem('userData')).account_type_id === 2 ||
      JSON.parse(localStorage.getItem('userData')).account_type_id === 4;
  }
};
</script>

<style scoped>
.confirmation-page {
  padding: 0px 20px;
}
.cnf-hr-line {
  margin: 0px 20px 16px;
}
.cnf-hr-line-regTracker {
  padding-right: 0px;
}
.cnf-hr-line-regTracker hr {
  margin-top: 0px;
}
.cnf-hr-line-renews {
  padding-left: 0px;
}
.cnf-hr-line-renews hr {
  margin-top: 0px;
}
.grp-single-service {
  margin-left: 15px;
}
.select-edit {
  padding-top: 12px;
}
.cnf-select-service {
  color: rgba(0, 0, 0, 0.7);
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
}
.cnf-end {
  text-align: end;
}
.cnf-end p {
  color: #0b3c61;
  font-size: 16px;
  line-height: 19px;
  cursor: pointer;
}
.cnf-selected {
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.7);
}
.text-end {
  text-align: end;
}
.pr-0 {
  padding-right: 0;
}
.pt-40 {
  padding-top: 40px;
}
.mb-0 {
  margin-bottom: 0;
}
.note-text {
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  padding-bottom: 20px;
}
.cnf-single-service {
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
}
.billing-info-edit {
  padding-top: 20px;
}
.payment-mthd-edit {
  padding-top: 36px;
}
.font-bold {
  font-weight: bold;
}
.cnf-credit-card {
  text-align: end;
  font-size: 16px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
}
.cnf-sngl-service {
  font-size: 14px;
  line-height: 16px;
  color: #828282;
}
.success-msg {
  font-size: 18px;
  color: #4c9e45;
  font-weight: bold;
}

.renewal-label {
  line-height: 21px;
  color: #4c9e45;
}

.pl-16 {
  padding-left: 16px;
}

.service-header {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  padding-left: 25px;
}

.service-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
}

@media screen and (min-width: 768px) {
  .renew_label {
    text-align: right;
  }
}
@media screen and (max-width: 767px) {
  .renew_label {
    text-align: left;
  }
  .cnf-hr-line-regTracker {
    padding-right: 15px;
  }
  .grp-single-service {
    margin-left: 0px;
  }
  .billing-info-edit {
    padding-top: 7px;
  }
  .cnf-selected {
    font-size: 16px;
    line-height: 19px;
    color: #000000;
    padding-top: 15px;
  }
  .cnf-single-service {
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
  }
  .selected-service-border {
    margin-top: 23px;
    border: 1px solid #d3d6d9;
    box-sizing: border-box;
    border-radius: 13px;
  }
  .cnf-sngl-service {
    padding-left: 0px;
  }
  .cnf-credit-card {
    text-align: left;
    font-weight: bold;
  }
  .payment-mthd-edit {
    padding-top: 25px;
  }
  .cnf-sm-address {
    padding-top: 18px;
  }
  .cnf-hr-line {
    margin: 0px 20px;
  }
  .note-text {
    padding-top: 10px;
  }
  .cnf-sm-border {
    margin-top: 9px;
    margin-bottom: 25px;
  }
}
</style>
